import { put, putResolve, takeEvery } from 'redux-saga/effects';
import * as actions from '../../actions/utility-actions';
import { IDocumentRequest } from '../../models/utilities/document-request';
import { ToastMessage } from '../../models/utilities/toast-message';
import { DocumentUtils } from '../../utils/document-utils';

export function* getDocumentWorker(action : IReduxAction) {
    
    const request = action.payload as IDocumentRequest;
    
    try {
        yield put(actions.showDownloading());
    
        const report = yield putResolve(actions.fetchBlob(request.url, request.reportLocation, request.methodType, request.data, request.contentType));

        if (report.size > 0) {
            DocumentUtils.openDoc(report, request.filename, request.openInTab, request.fileExtension);
        }
        else {
            throw Error("We're unable to find that document!");
        }
    }
    catch (err) {
        console.error(err, request);
        if (err && err.message) {
            yield put(actions.showToastNotification(new ToastMessage(err.message, "error")));            
        }
    }

    yield put(actions.hideDownloading());
}

/**
 * Watch for open dealer order actions
 */
export function* getDocumentWatcher() {
    yield takeEvery(actions.UTILITY_GET_DOCUMENT, getDocumentWorker);
}
